import { Listbox } from "@headlessui/react";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../../helpers/commonFunction";
import { AppState } from "../../../../../../stateManager/store";
import { data } from "../data";
import { ReactComponent as DropdownIcon } from "../../../../../../assets/svg/solobuilder/dropdown.svg";
import { pushFormActionStack, updateElement, updateElementOnUndoRedo } from "../../../../../../stateManager/store/formCreation_v2/actions";
import { getValue, getComponents } from "../../helpers";
import { myRedoStack, myUndoStack } from "../../stack/Stack";

// import { onChange } from "./helpers/on-change"

// const DEFAULT_HEIGHT: string = "properties.styles.$deviceType.height";
// const DEFAULT_HEIGHT_MODE: string = "properties.styles.$deviceType.heightMode";
const HEIGHT_LABEL = "Height";

const excluded_types = [
  "CheckBox",
  "RadioButton",
  "Otp"
]

type Props = {
  isCheckedIn: boolean;
  defaultValue?: string;
}

export const Height = (props: Props) => {
  const { components } = getComponents()
  const { selectedElementId, deviceType, isCoreV3, wrapperComputedStyles, computedStyles } = useSelector((state: AppState) => state.formJson)
  const { isCheckedIn, defaultValue } = props;
  const component = components[selectedElementId];
  const { type } = component;
  const dispatch = useDispatch()
  const heightOptions = data.heightMode ? data.heightMode.map((el) => ({ name: el.label, value: el.value })) : []
  const onChangeMode = (key: string, value: any, name: string) => {
    // Store the current value as oldValue
    const oldValue = {
      height: getValue(component, 'properties.styles.$deviceType.height'.split('.'), deviceType) ?? calculateHeight(),
      heightMode: getValue(component, 'properties.styles.$deviceType.heightMode'.split('.'), deviceType)
    };

    if (key === 'properties.styles.$deviceType.heightMode') {
      myUndoStack.push({
        id: selectedElementId,
        path: key,
        value: oldValue,
        label: "",
        properties: {},
        type: "",
        fields: []
      });
      myRedoStack.clear();
    }

    dispatch(updateElement({
      id: selectedElementId,
      path: key,
      value
    }));

    let heightValue = "";
    if (value === "auto") {
      heightValue = "auto";
    } else if (value === "min-content") {
      heightValue = "min-content";
    } else if (value === "max-content") {
      heightValue = "max-content";
    } else {
      heightValue = value;
    }

    // Determine height mode based on value
    let heightMode = value;
    if (name === "%") {
      heightMode = "%";
    }
    if (name === "px") {
      heightMode = "px";
    }

    // Store the updated value as newValue
    const newValue = {
      height: heightValue,
      heightMode: heightMode
    };

    dispatch(pushFormActionStack({
      undo: () => {
        const poppedElement = myUndoStack.pop();
        if (poppedElement) {
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: 'properties.styles.$deviceType.height',
            value: poppedElement.value.height || "",
            increment: -1
          }));
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: 'properties.styles.$deviceType.heightMode',
            value: poppedElement.value.heightMode || "",
            increment: -1
          }));
          myRedoStack.push({ ...poppedElement, value: newValue });
        }
      },
      redo: () => {
        const poppedElement = myRedoStack.pop();
        if (poppedElement) {
          const oldValue = {
            height: getValue(component, 'properties.styles.$deviceType.height'.split('.'), deviceType) ?? calculateHeight(),
            heightMode: getValue(component, 'properties.styles.$deviceType.heightMode'.split('.'), deviceType)
          };
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: 'properties.styles.$deviceType.height',
            value: poppedElement.value.height,
            increment: 1
          }));
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: 'properties.styles.$deviceType.heightMode',
            value: poppedElement.value.heightMode,
            increment: 1
          }));
          myUndoStack.push({ ...poppedElement, value: oldValue });
        }
      }
    }));
  };

  const onChange = (key: string, value: any) => {
    const oldValue = getValue(component, key.split('.'), deviceType) ? getValue(component, key.split('.'), deviceType) : calculateHeight();
    myUndoStack.push({
      id: selectedElementId,
      path: key,
      value: oldValue,
      label: "",
      properties: {},
      type: "",
      fields: []
    })
    myRedoStack.clear();
    dispatch(updateElement({
      id: selectedElementId,
      path: key,
      value
    }))
    dispatch(pushFormActionStack({
      undo: () => {
        const poppedElement = myUndoStack.pop();
        if (poppedElement) {
          myRedoStack.push({ ...poppedElement, value })
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: poppedElement.path,
            value: poppedElement.value || "",
            increment: -1
          }))
        }
      },
      redo: () => {
        const poppedElement = myRedoStack.pop();
        if (poppedElement) {
          myUndoStack.push({ ...poppedElement, value: oldValue });
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: poppedElement.path,
            value: poppedElement.value,
            increment: 1
          }))
        }
      }
    }))
  }


  const heightMode: string = component.properties.styles[deviceType].heightMode || "px";

  useEffect(() => {
    if (!(component.properties.styles[deviceType].heightMode)) {
      if (type === "ExpansionPanel") {
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.$deviceType.heightMode`, value: "auto" }));
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.$deviceType.height`, value: "auto" }));
      } else if (type === "Column" || type === "TabBar") {
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.$deviceType.heightMode`, value: "%" }));
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.$deviceType.height`, value: "100" }));
      }else if(type === "FlatList") {
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.Sm.heightMode`, value: "%" }));
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.Sm.height`, value: "100" }));
      }
       else {
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.$deviceType.heightMode`, value: "px" }));
        dispatch(updateElement({ id: selectedElementId, path: `properties.styles.$deviceType.height`, value: component.properties.styles[deviceType].height }));
      }
    }
  }, [deviceType, computedStyles])

  const layout_components = [
    "Row",
    "Column",
    "Grid",
    "Container",
    "A8Modal",
    "CustomModal"
  ]

  const calculateHeight = () => {
    const deviceHeight = getValue(
      component,
      ["properties", "styles", deviceType, "height"],
      deviceType
    )
    if (deviceHeight === undefined) {
      let wrapperStyles: any;
      if (layout_components.includes(type)) {
        wrapperStyles = wrapperComputedStyles
      } else {
        wrapperStyles = computedStyles;
      }
      const height = (wrapperStyles && wrapperStyles.height && wrapperStyles.height.match(/\d+/) ? wrapperStyles.height.match(/\d+/)[0] : null);
      return height;
    }
    return deviceHeight
  }

  const getHeightMode = () => {
    const deviceHeightMode = getValue(component, `properties.styles.$deviceType.heightMode`.split("."), deviceType)
    if (!deviceHeightMode) {
      const reg = /([a-z%]+)/
      const wrapperStyles = wrapperComputedStyles.hasOwnProperty("height") ? wrapperComputedStyles : computedStyles;
      const heightMode = (wrapperStyles && wrapperStyles.height && wrapperStyles.height.match(reg) ? wrapperStyles.height.match(reg)[0] : null);
      return heightMode
    }
    return deviceHeightMode
  }

  const componentsWithAutoHeight = ["Text",
    "Button",
    "IconButton",
    "Link",
    "Row",
    "Column",
    "Grid",
    "Container",
    "ExpansionPanel",
    "TabBar"
  ];

  const filteredHeightMode = componentsWithAutoHeight.includes(type)
    ? heightOptions
    : heightOptions.filter(option => option.name.toLowerCase() !== "auto");

  if (isCoreV3 && excluded_types.includes(type)) {
    return null
  }

  return (
    <div className="panel-div">
      <label
        htmlFor="height"
        className="panel-label"
      >
        {HEIGHT_LABEL}
      </label>
      <div
        style={{ cursor: !isCheckedIn ? "not-allowed" : "auto" }}
        className="panel-input flex items-center"
        data-test-id={`${type}-${HEIGHT_LABEL}`}
      >
        <div className="relative w-1/2 bg-white text-gray-900" style={heightMode === "%" || heightMode === "px" ? { borderRight: "#B4B4B4 solid 1px" } : { width: "100%", paddingLeft: 0 }}>
          <Listbox disabled={!isCheckedIn}
            value={{ name: data.heightMode.find(item => item.value === getHeightMode())?.label ?? data.heightMode[0].label }}
            onChange={(option) => {
              if (data.heightMode) {
                const item = data.heightMode.find(item => item.label === option.name)
                if (item) {
                  onChangeMode(`properties.styles.$deviceType.heightMode`, item.value, option.name)
                  if (option.name === "%" || option.name === "px") {
                    onChangeMode(`properties.styles.$deviceType.height`, "100", option.name)
                  } else {
                    onChangeMode(`properties.styles.$deviceType.height`, item.value, option.name)
                  }
                }
              }
            }}>
            <Listbox.Button data-test-id={`${type}-height_mode-button`} className="flex w-full cursor-pointer rounded-sm bg-white items-center h-full focus:outline-none justify-between">
              <span style={{fontSize:"12px",height:"19px"}}>{data.heightMode.find(item => item.value === getHeightMode())?.label ?? data.heightMode[0].label}</span>
              <span className="pointer-events-none pr-2">
                <DropdownIcon className="h-3 w-3 text-gray-400" />
              </span>
            </Listbox.Button>

            <Listbox.Options data-test-id={`${type}-height_mode-options`} style={{ marginTop: "10px", marginLeft: "-6px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "0px 5px 8px rgba(125, 132, 146, 0.11)", borderRadius: "4px", width: "170px", maxHeight:"175px", color:"#505f7b", fontSize:"12px", paddingBottom: "10px" }}
            className="absolute max-h-60 w-52 overflow-auto rounded-md bg-white focus:outline-none z-40">
              {filteredHeightMode.map((type, colorIdx) => (
                <Listbox.Option
                  key={colorIdx}
                  style={{ margin: "10px 10px 0px 10px" }}
                  className={({ active }) => `relative cursor-pointer select-none ${active ? "text-selectedText_color":""}`}
                  value={type}
                  data-test-id={`height_mode-${type.name}`}
                >
                  <span className={`block truncate ${heightMode===type.value ? "text-selectedText_color":""}`} style={{lineHeight: "normal"}}>
                    {type.name}
                  </span>
                </Listbox.Option>
              ))}
            </Listbox.Options>
          </Listbox></div>
        <br />
        {heightMode === "%" || heightMode === "px" ?
          <input
            style={{ cursor: !isCheckedIn ? "not-allowed" : "auto" }}
            disabled={!isCheckedIn}
            type="text"
            id="height"
            data-test-id={`${type}-${HEIGHT_LABEL}-input`}
            className="col-span-2 bg-white text-gray-900 rounded-sm px-3 w-1/2 border-0 h-full outline-none"
            // value={`${getValue(component, `properties.styles.$deviceType.height`.split("."), deviceType)}`}
            value={
              isCoreV3 ?
                calculateHeight()
                : getValue(component, `properties.styles.$deviceType.height`.split("."), deviceType)
            }
            onChange={(e: any) => {
              let value = e.target.value
              const regex = /^(\s*|\d+)$/
              const isValid = regex.test(value)
              const item = heightMode === "%"
              if (item && isValid && value > 100) {
                value = 100
              }
              isValid && onChange(`properties.styles.$deviceType.height`, value)
            }}
          />
          :
          <div></div>
        }
      </div>
    </div>
  )
};
